export const CONTACT_FORM_REQUEST = 'CONTACT_FORM_REQUEST';
export const CONTACT_FORM_SUCCESS = 'CONTACT_FORM_SUCCESS';
export const CONTACT_FORM_FAIL = 'CONTACT_FORM_FAIL';


export const EMAIL_LIST_REQUEST = 'EMAIL_LIST_REQUEST';
export const EMAIL_LIST_SUCCESS = 'EMAIL_LIST_SUCCESS';
export const EMAIL_LIST_FAIL = 'EMAIL_LIST_FAIL';
